/** Pure request intent; no browser state, credentials, tenancy or permissions. */
export type CoachingScopeIntent = {
  team_id: string;
  season: { mode: "current"; season_id: string } | { mode: "unseasoned" };
};

/** Existing web callers may omit mode and retain saved/default semantics. */
export type CoachingTransportScope = {
  teamId?: string | null;
  seasonId?: string | null;
  seasonMode?: "current" | "unseasoned";
};

export function scopeQuery(scope: CoachingTransportScope): Record<string, string> {
  const query: Record<string, string> = {};
  if (scope.teamId) query.team_id = scope.teamId;
  if (scope.seasonMode === "unseasoned") {
    if (scope.seasonId !== null && scope.seasonId !== undefined) {
      throw new RangeError("conflicting_season_selection");
    }
    query.season_scope = "unseasoned";
  } else {
    if (scope.seasonId) query.season_id = scope.seasonId;
    if (scope.seasonMode === "current") query.season_scope = "current";
  }
  return query;
}

export function pinnedScope(intent: CoachingScopeIntent): CoachingTransportScope {
  if (!intent.team_id || (intent.season.mode === "current" && !intent.season.season_id)) {
    throw new RangeError("invalid_scope_selection");
  }
  return intent.season.mode === "unseasoned"
    ? { teamId: intent.team_id, seasonId: null, seasonMode: "unseasoned" }
    : { teamId: intent.team_id, seasonId: intent.season.season_id, seasonMode: "current" };
}
